<template>
  <div class="slider">
    <div class="back_add">
      <div class="threeImg">
        <div class="Containt">
          <div class="iconleft" @click="zuohua">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div :style="{ left: calleft + 'px' }" class="sliderContent">
            <div class="sliderItem" v-for="(item, index) in list" :key="index">
              <router-link target="_blank" tag="a" :to="'/resource/detail?rscId=' + item.rscID">
                <img :src="item.rscImage" />
                <p>{{ item.title }}</p>
              </router-link>
            </div>
          </div>
          <div class="iconright" @click="youhua">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "slider",
  props: ["sliderList"],
  data() {
    return {
      calleft: 0,
      list: []
    };
  },
  mounted() {
    this.handleList();
  },
  methods: {
    //处理一个图片，或者两个图片的情况
    handleList() {
      if (!this.sliderList) return;
      if (this.sliderList.length === 1) {
        this.list.push(...JSON.parse(JSON.stringify(this.sliderList)));
        this.list.push(...JSON.parse(JSON.stringify(this.sliderList)));
        this.list.push(...JSON.parse(JSON.stringify(this.sliderList)));
      } else if (this.sliderList.length === 2) {
        this.list.push(...JSON.parse(JSON.stringify(this.sliderList)));
        this.list.push(...JSON.parse(JSON.stringify(this.sliderList)));
      } else {
        this.list = JSON.parse(JSON.stringify(this.sliderList));
      }
    },
    //点击按钮左移
    zuohua() {
      // let last = this.list.shift();
      // this.list.push(last);
      if (this.list.length > 3) {
        this.calleft -= 240;
        if (this.calleft < -((this.list.length - 3) * 240)) {
          this.calleft = 0;
        }
      }
    },
    //点击按钮右移
    youhua() {
      // let first = this.list.pop();
      // this.list.unshift(first);
      if (this.list.length > 3) {
        this.calleft += 240;
        if (this.calleft > 0) {
          this.calleft = -(this.list.length - 3) * 240;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.slider {
  #divAdd {
    background-color: #fff;
    width: 1000px;
    margin: 0px auto;
  }

  .divAdd-con {
    margin: 0px auto;
    width: 1000px;
    overflow: auto;
    padding: 30px 0px;
  }

  .back_add {
    background-color: #fff;
  }

  a:focus,
  a:hover {
    color: #23527c;
  }

  .threeImg {
    height: 158px;
    background: #fff;
    min-width: 1000px;
  }

  .sliderContent {
    margin: 0 auto;
    position: absolute;
    left: 0px;
    cursor: pointer;
    height: 100%;
    transition: left 0.3s linear;
  }

  .sliderItem {
    width: 200px;
    margin: 10px 20px;
    margin-top: 20px;
    float: left;
    img {
      height: 110px;
      width: 100%;
    }
    p {
      color: #333;
      text-align: center;
      font-size: 16px;
    }
  }

  .Containt {
    position: relative;
    width: 1000px;
    height: 150px;
    margin: 0 auto;
    overflow: hidden;
  }

  .iconleft {
    position: absolute;
    width: 20px;
    top: -5px;
    z-index: 99999;
    padding-top: 48px;
    vertical-align: middle;
    font-size: 50px;
    color: #1082ff;
  }

  .iconright {
    position: relative;
    left: 670px;
    top: -5px;
    z-index: 99999;
    padding-top: 48px;
    vertical-align: middle;
    font-size: 50px;
    color: #1082ff;
  }
}
</style>
